import {useState} from 'react';
import {useTheme} from '@material-ui/core/styles';
import useWindowResize from 'shared/hooks/useWindowResize';

export default function useIsMobile(): boolean {
  const theme = useTheme();
  const [isMobile, setIsMobile] = useState(
    window.matchMedia(`(max-width: ${theme.breakpoints.values.sm}px)`).matches
  );
  useWindowResize(() =>
    setIsMobile(window.matchMedia(`(max-width: ${theme.breakpoints.values.sm}px)`).matches)
  );
  return isMobile;
}
